// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Senegal from '../_raw/flag/icon_flag_senegal.png';

export default () => <img src={Senegal} alt="Senegal" />;
